export const PDF_TYPE = "data:application/pdf;base64";
export const PNG_TYPE = "data:image/png;base64";

export const convertBase64ToBlob = (base64str: string): Blob => {
  // Split into two parts
  const parts = base64str.split(";base64,");

  // Get the content type
  const type = parts[0].split(":")[1];

  // Decode Base64 string
  const decodedData = window.atob(parts[1]);

  // Create UNIT8ARRAY of size same as row data length
  const uint8Array = new Uint8Array(decodedData.length);

  // Insert all character code into Uint8Array
  for (let i = 0; i < decodedData.length; i++) {
    uint8Array[i] = decodedData.charCodeAt(i);
  }

  // Return Blob after conversion
  return new Blob([uint8Array], { type });
};
